import styled from 'styled-components'

export const ModalBody = styled.div`
display: flex;
flex-direction: column;
align-items: center;
padding: 1rem 1rem 0 1rem;
font-size: 14px !important;

strong{
    color: var(--vm4);
    font-weight: 900;
}

small{
    color: var(--terc3);
    font-weight: 500;
    font-size: 14px !important;
}

span{
    color:var(--a5);
}
`
